import React, { useEffect, useState } from "react"

import "shared/styles/lxoDashboardTokens.css"

// Components
import { Grid } from "@mui/material"
import MDBox from "components/MDBox"
import Advertise from "components/Advertise"
import Category from "components/Category/Category"

import PerformanceCardsLXO from "components/PerformanceCardsLXO/PerformanceCardsLXO"
import CenterDashboardSection from "components/CenterDashboardSection/CenterDashboardSection"

// Context
import { useMaterialUIController } from "context"
import { RoleLabel, Role } from "constant/Role"
// Sample
import {
  workStation,
  LXOLinks,
  otherRoleLinks,
  otherRoleLinksImageUrl,
} from "constant/ExternalLinks"
import { containerStyle, headerStyle } from "components/Category/style"
import InfoIcon, { TooltipIconColor, TooltipType } from "components/InfoIcon"
import { teacherInfoIconBlock } from "components/InfoIcon/teacherInfoIcon"
import MDTypography from "components/MDTypography"

// Redux
import { useLazyGetPerformanceLXOQuery } from "shared/redux/endpoints/lxo"
import { selectAuth } from "shared/redux/slices/authSlice"
// Styles
import makeStyles from "pages/style"
import { homeStyles } from "pages/home/style"

import { cardsLXO } from "pages/home/data/card"
import { useSelector } from "react-redux"
import MyTeamLXO from "components/MyTeamLXO/MyTeamLXO"
import StoryLXO from "components/StoryLXO/StoryLXO"

const HomeBoxByRoleLXO = ({ showPerformanceCards = true }) => {
  const classes = makeStyles()
  const [step, setStep] = useState(0)

  const auth = useSelector(selectAuth)

  const [controller] = useMaterialUIController()
  const { miniSidenav } = controller

  const [triggerGetPerformance, { data: dataPerformance, isLoading }] =
    useLazyGetPerformanceLXOQuery()

  const role = auth.role

  // console.log("dataPerformance", dataPerformance);

  const getCardValues = (index) => {
    if (!dataPerformance?.data) return { progress: 0, diff: 0 }

    switch (index) {
      case 0: {
        const currentWeekRate =
          dataPerformance?.data?.taskToDay?.deadlineTask ?? 0
        const lastWeekRate = dataPerformance?.data?.taskToDay?.overdueTask ?? 0
        return {
          progress: currentWeekRate,
          diff: currentWeekRate - lastWeekRate,
          information: "lorem ipsum",
        }
      }
      case 1: {
        const currentWeekCompleteRate =
          dataPerformance?.data?.appCompletion?.completionThisWeek ?? 0
        const lastWeekCompleteRate =
          dataPerformance?.data?.appCompletion?.completionLastWeek ?? 0
        return {
          progress: currentWeekCompleteRate,
          diff: currentWeekCompleteRate - lastWeekCompleteRate,
        }
      }
      case 2: {
        const currentWeekTeachingHours =
          dataPerformance?.data?.workbookCompletion?.completionThisWeek ?? 0
        const lastWeekTeachingHours =
          dataPerformance?.data?.workbookCompletion?.completionLastWeek ?? 0
        return {
          progress: currentWeekTeachingHours,
          diff: currentWeekTeachingHours - lastWeekTeachingHours,
        }
      }
      case 3: {
        const lastWeekConversionRate =
          dataPerformance?.data?.teacherChangeRate?.lastWeekRate ?? 0
        const currentWeekConversionRate =
          dataPerformance?.data?.teacherChangeRate?.currentWeekRate ?? 0
        return {
          progress: currentWeekConversionRate,
          diff: currentWeekConversionRate - lastWeekConversionRate,
        }
      }
      case 4: {
        const lastWeekConversionRate =
          dataPerformance?.data?.teacherEfficiency?.lastWeekRate ?? 0
        const currentWeekConversionRate =
          dataPerformance?.data?.teacherEfficiency?.currentWeekRate ?? 0
        return {
          progress: currentWeekConversionRate,
          diff: currentWeekConversionRate - lastWeekConversionRate,
        }
      }
      case 5: {
        const lastWeekConversionRate =
          dataPerformance?.data?.cancellation?.completionLastWeek ?? 0
        const currentWeekConversionRate =
          dataPerformance?.data?.cancellation?.completionThisWeek ?? 0
        return {
          progress: currentWeekConversionRate,
          diff: currentWeekConversionRate - lastWeekConversionRate,
        }
      }
      default:
        return { progress: 0, diff: 0 }
    }
  }

  const linksCategory = auth.role === RoleLabel[Role.LXO] ? LXOLinks : otherRoleLinks

  useEffect(() => {
    if (!showPerformanceCards) return
    triggerGetPerformance({ centerId: auth?.centerId })
  }, [auth?.centerId, showPerformanceCards])

  const [activeTeam, setActiveTeam] = useState(null)

  return (
    <>
      <MDBox sx={(theme) => homeStyles(theme, { miniSidenav })}>
        {/* zone 1 */}
        {showPerformanceCards && (
          <PerformanceCardsLXO
            isLoading={isLoading}
            cards={cardsLXO}
            getCardValues={getCardValues}
          />
        )}

        <MDBox mt={2.5} mb={2.5} className="story-section">
          <StoryLXO activeTeam={activeTeam} setActiveTeam={setActiveTeam} />
        </MDBox>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="stretch"
          mt={0}
          columnSpacing={3}
          rowGap={3}
          sx={{ height: "100%" }}
          className="category-section"
        >
          <Grid item width="100%" xs={12} xl={5} xxl={5}>
            <MyTeamLXO activeTeam={activeTeam} setActiveTeam={setActiveTeam} />
          </Grid>
          <Grid item width="100%" xs={12} xl={3.5} xxl={3.5}>
            <Category index={0} category={workStation} />
          </Grid>
          <Grid item width="100%" xs={12} xl={3.5} xxl={3.5}>
            {showPerformanceCards ? (
              <Category index={1} category={linksCategory} />
            ) : (
              <MDBox sx={(theme) => containerStyle(theme, { index: 1 })}>
                <InfoIcon
                  type={TooltipType.TYPE_2}
                  teacherInfoIconBlock={teacherInfoIconBlock.LINKS}
                  color={TooltipIconColor.BLUE}
                >
                  <MDTypography
                    variant="h5"
                    sx={(theme) => headerStyle(theme, { index: 1 })}
                  >
                    LINKS
                  </MDTypography>
                </InfoIcon>
                <MDBox
                  component="img"
                  src={otherRoleLinksImageUrl}
                  alt="Links"
                  sx={{
                    width: "100%",
                    flex: 1,
                    objectFit: "contain",
                    borderRadius: "8px",
                  }}
                />
              </MDBox>
            )}
          </Grid>
        </Grid>

        {/* zone 2 */}
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="stretch"
          sx={({ breakpoints, functions: { pxToRem } }) => ({
            marginTop: pxToRem(20),

            [breakpoints.down("xxl")]: {
              rowGap: 4,
            },
          })}
          columnSpacing={2.5}
          height="100%"
        >
          <CenterDashboardSection step={step} setStep={setStep} />
          {step === 0 && (
            <Grid
              item
              xs={12}
              lg={4}
              xxl={4.5}
              sx={{ minHeight: 600 }}
              className="advertise-section"
            >
              <Advertise />
            </Grid>
          )}
        </Grid>
      </MDBox>
    </>
  )
}

export default HomeBoxByRoleLXO
